import React, {useState, useEffect} from 'react';
import {
    Button,
    TextField,
    Card,
    CardContent,
    CardHeader,
    Typography,
    CircularProgress,
    Grid,
    Divider
} from '@mui/material';
import EuroIcon from '@mui/icons-material/Euro';

// Simulated BergPay interface
window.BergPay = {
    updatePaymentStatus: function (resultCodeParam, paymentResponse) {
        window.dispatchEvent(new CustomEvent('BergPayStatusUpdate', {detail: {paymentResponse: paymentResponse, resultCode: resultCodeParam}}));
    },
};

const BergPayDemo = () => {
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('WAITING');
    const [response, setResponse] = useState('Last Payment Response');

    const getInvoiceNumber = () => {
        const now = new Date();
        const dateString = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
        const randomNumber = Math.floor(Math.random() * 1000);
        return `BILL/${dateString}/${randomNumber}`;
    };

    const [invoiceNumber] = useState(getInvoiceNumber());

    useEffect(() => {
        const handleStatusUpdate = (event) => {
            console.log('handleStatusUpdate: ' + JSON.stringify(event.detail));

            if (event.detail && event.detail.resultCode&& event.detail.resultCode === '0') {
                setStatus('SUCCESS');
            } else {
                setStatus('FAILED');
            }
            setLoading(false);

            setResponse(
                event.detail.paymentResponse
            );
        };

        window.addEventListener('BergPayStatusUpdate', handleStatusUpdate);

        return () => {
            window.removeEventListener('BergPayStatusUpdate', handleStatusUpdate);
        };
    }, [amount]);

    const handleAmountChange = (e) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }
        setAmount(value);
    };

    const handlePayment = () => {
        setLoading(true);
        setStatus('STARTING');
        setResponse('');

        console.log('Starting payment for amount: ' + amount);
        window.BergPayDevice.startPayment(amount);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'SUCCESS':
                return 'green';
            case 'FAILED':
                return 'red';
            default:
                return 'gray';
        }
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px'}}
        >
            <Grid item xs={12} sm={10} md={8} lg={6} style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Card style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                    <CardHeader
                        title={
                            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                                <span>BergPay<sup style={{fontSize: '0.6em'}}>®</sup> Demo</span>
                            </div>
                        }
                        titleTypographyProps={{align: 'center', variant: 'h3', style: {color: '#388E3C'}}}
                        style={{
                            padding: '16px',
                            borderRadius: '4px'
                        }}
                    />
                    <CardContent style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                        <Grid container spacing={2} style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Amount"
                                    value={amount}
                                    onChange={handleAmountChange}
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{
                                        endAdornment: <EuroIcon/>,
                                    }}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9.,]*'
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Invoice Number"
                                    value={invoiceNumber}
                                    disabled
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    onClick={handlePayment}
                                    variant="contained"
                                    fullWidth
                                    disabled={loading || !amount}
                                    style={{
                                        backgroundColor: loading || !amount ? '#A5D6A7' : '#388E3C', // Light green when disabled, dark green when enabled
                                        color: '#fff',
                                    }}
                                >
                                    {loading ? <CircularProgress size={24} style={{color: 'white'}}/> : 'Start Payment'}
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{margin: '16px 0'}}/> {/* Added Divider here */}
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h6"
                                    align="center"
                                    style={{
                                        padding: '8px',
                                        backgroundColor: getStatusColor(status),
                                        color: '#fff',
                                        borderRadius: '4px'
                                    }}
                                >
                                    {status}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}
                                  style={{flexGrow: 1, display: 'flex', flexDirection: 'column', marginTop: '15px'}}>
                                <Typography variant="subtitle1" style={{marginBottom: '8px'}}>
                                    Payment response:
                                </Typography>
                                <TextField
                                    value={response}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={8} // Default rows
                                    disabled={true}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    style={{
                                        flexGrow: 1,
                                        overflowY: 'auto',
                                        maxHeight: '200px',
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default BergPayDemo;
